import {
  FETCH_DEAL,
  FETCH_DEAL_SUCCESS,
  FETCH_DEAL_ERROR,
  SAVE_DEAL,
  SAVE_DEAL_SUCCESS,
  SAVE_DEAL_ERROR,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: null,
  loading: false,
  saving: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  // console.log('action received: ', action);
  switch(action.type){
    case FETCH_DEAL:
      return {
        ...state,
        data: null,
        loading: true,
        error: null,
      }
    break;
    case FETCH_DEAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    break;
    case FETCH_DEAL_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      }
    break;
    case SAVE_DEAL:
      return {
        ...state,
        data: action.payload,
        saving: true,
        error: null,
      }
    break;
    case SAVE_DEAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        saving: false,
        error: null,
      }
    break;
    case SAVE_DEAL_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload,
      }
    break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/dealReducer.js